export const isMobileCrawlingEnabled = (sitemapAdaptiveType: string) =>
  sitemapAdaptiveType === 'all' || sitemapAdaptiveType === 'mobile';

export const isDesktopCrawlingEnabled = (sitemapAdaptiveType: string) =>
  sitemapAdaptiveType === 'all' || sitemapAdaptiveType === 'desktop';

export const sitemapAdaptiveTypeToArray = (sitemapAdaptiveType: string, mobileAdaptive: boolean) =>
  !mobileAdaptive
    ? ['desktop']
    : [
        ...(isMobileCrawlingEnabled(sitemapAdaptiveType) ? ['mobile'] : []),
        ...(isDesktopCrawlingEnabled(sitemapAdaptiveType) ? ['desktop'] : []),
      ];

export const arrayToAdaptiveType = (adaptiveTypes: string[], mobileAdaptive: boolean) =>
  !mobileAdaptive
    ? 'desktop'
    : adaptiveTypes.includes('desktop') && adaptiveTypes.includes('mobile')
    ? 'all'
    : adaptiveTypes.includes('desktop')
    ? 'desktop'
    : 'mobile';

export type SitemapOrigin = 'gsc' | 'user' | 'auto';

// `sitemap_settings.type` values are historically inconsistent (e.g. both 'auto'
// and 'automatic' exist), so classify by substring rather than exact match.
// Returns null for unrecognised types so callers can render nothing.
export const getSitemapOrigin = (type: string): SitemapOrigin | null => {
  const value = type?.toLowerCase() ?? '';
  if (value.includes('gsc')) return 'gsc';
  if (value.includes('user')) return 'user';
  if (value.includes('auto')) return 'auto';
  return null;
};

export const SITEMAP_ORIGIN_LABELS: Record<SitemapOrigin, string> = {
  gsc: 'GSC import',
  user: 'User upload',
  auto: 'Auto-discovered',
};

export const HOURS_IN_SECONDS = 60 * 60;

export const hoursToString = (hours: number) => (hours === 1 ? '1 hour' : `${hours} hours`);
export const daysToString = (days: number) => (days === 1 ? '1 day' : `${days} days`);

export function strigifyRevisitInterval(seconds: number) {
  const intervalHours = seconds / 60 / 60;

  if (intervalHours >= 48) {
    const days = Math.floor(intervalHours / 24);
    return daysToString(days);
  }

  return hoursToString(intervalHours);
}
